export default "__VITE_ASSET__BsHu9mt9__"